module.exports = __webpack_public_path__ + "static/media/resourcesSuccess.21066724.svg";